






























































































// @ is an alias to /src
import { Component, Prop, Vue } from "vue-property-decorator";
import Header from "../components/Header.vue";
import Title from "../components/Title.vue";
import TitleFomatter from "../components/Type/TitleFomatter";
import ListFomatter from "../components/Type/ListFomatter";
import Tip from "@/components/Tip.vue";
// swiper
import Swiper from "swiper";
import "swiper/swiper.scss";
//utils
import Utils from "../utils/utils";

@Component({
  components: {
    Title,
    Tip
  }
})
export default class Home extends Utils {
  private homeMinHeight: number = 0;
  private adList: ListFomatter[] = [
    {
      title: "免开发，直接使用",
      subtitle:
        "我们已经做好一套完整的应用体系 商家只需要下载打印二维码物料即可售卖使用。",
      img: "ad-icon.png"
    }
  ];
  private bannerIconList: ListFomatter[] = [
    { title: "物品丢失", img: "banner-icon1.png" },
    { title: "临时挪车", img: "banner-icon2.png" },
    { title: "宠物走丢", img: "banner-icon3.png" }
  ];
  private contactList: ListFomatter[] = [
    {
      title: "留言功能",
      subtitle: "电话不能联系时，还能留言对话。",
      img: "cont-icon1.png"
    },
    {
      title: "拉黑功能",
      subtitle:
        "拒绝骚扰，一键拉黑。拉黑后，将禁止对方向您拨打隐私电话、发送留言。",
      img: "cont-icon2.png"
    }
  ];
  private infoList: ListFomatter[] = [
    {
      title: "无需安装",
      subtitle: "微信扫码即可绑定",
      img: "info-icon1.png"
    },
    {
      title: "门槛最低",
      subtitle: "微信扫码即可联系",
      img: "info-icon2.png"
    },
    {
      title: "贴心设计",
      subtitle: "一键禁止被呼叫",
      img: "info-icon3.png"
    }
  ];
  private funcList: ListFomatter[] = [
    {
      title: "一贴防丢 方便快捷",
      subtitle:
        "将二维码贴纸粘贴在任何容易丢失的物品上，等于为这个物品购买了一份防丢的保险。",
      img: "func-icon1.png"
    },
    {
      title: "一扫寻主  简单直接",
      subtitle: "好心人捡拾到您的物品，使用微信扫码即可通过加密电话联系到您",
      img: "func-icon2.png"
    }
  ];
  private situList: ListFomatter[] = [
    { title: "出差旅行防丢", img: "situ-icon1.png" },
    { title: "随身小物防丢", img: "situ-icon2.png" },
    { title: "停车场挪车", img: "situ-icon3.png" },
    { title: "老人小孩防丢", img: "situ-icon4.png" }
  ];
  private titleStyle: { [key: string]: TitleFomatter } = {
    title: {
      titleSize: 1.2,
      textAlign: "center",
      lineMargin: 7.5,
      lineWidth: 25,
      lineHeight: 2,
      lineRadius: 1,
      lineColor: "#FF8A22"
    },
    whiteTitle: {
      titleSize: 1.2,
      titleColor: "#fff",
      textAlign: "center",
      lineMargin: 7.5,
      lineWidth: 25,
      lineHeight: 2,
      lineRadius: 1,
      lineColor: "#fff"
    },
    subTitle: {
      titleSize: 1,
      textAlign: "left",
      lineWidth: 20,
      lineHeight: 1.5,
      lineRadius: 0.75,
      lineColor: "#FF8E31",
      lineMargin: 20
    }
  };
  created() {
    this.saveNavIndex("0");
    this.$store.commit("navChange", 0);
    //@ts-ignored
    this.homeMinHeight = this.$parent.minHeight;
  }
  mounted() {
    // const mySwiper = new Swiper('.swiper-container', {
    //   loop: true, // 循环模式选项
    //   autoplay: {
    //     delay: 1000
    //   },
    //   //设置断点宽度
    //   pagination: {
    //     el: '.swiper-pagination'
    //   },
    //   // 如果需要前进后退按钮
    //   navigation: {
    //     nextEl: '.swiper-button-next',
    //     prevEl: '.swiper-button-prev'
    //   }
    // });
  }
  private titleObj(style: string, title: string) {
    let newObj = {};
    Object.assign(newObj, this.titleStyle[style], { title });
    return newObj;
  }
  private changeNav() {
    this.$router.push("/download");
  }
}
